import {
  LOCATION_RESPONSE_RECEIVED,
  SET_ACTIVE_LOCATION,
  SET_ACTIVE_LOCATION_WITHOUT_SLOTS,
  LOCATION_FAILED,
  LOCATION_SLOTS_RECEIVED,
  LOCATION_SLOTS_FAILED,
} from '../constants';
import { ADD_SOLV_RATING } from '../ducks/solvRatings';
import { getNewOverallRatingsAndCounts } from '../core/util/rating';

export default function locationReducer(state = {}, action) {
  switch (action.type) {
    case ADD_SOLV_RATING:
      return {
        ...state,
        ...getNewOverallRatingsAndCounts(state, action.payload.rating),
      };
    case LOCATION_RESPONSE_RECEIVED:
    case SET_ACTIVE_LOCATION:
      return action.payload.value;
    case SET_ACTIVE_LOCATION_WITHOUT_SLOTS:
      return action.payload.value;
    case LOCATION_SLOTS_RECEIVED:
      return { ...state, slots: action.payload.value.slots };
    case LOCATION_FAILED:
      return { error: action.payload.value };
    case LOCATION_SLOTS_FAILED:
      return { error: action.payload.value };
    default:
      return state;
  }
}
